import { render, staticRenderFns } from "./AssignmentTimeUtilization.vue?vue&type=template&id=91e744e2&"
import script from "./AssignmentTimeUtilization.vue?vue&type=script&lang=js&"
export * from "./AssignmentTimeUtilization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports